import cn from "classnames";
import Button, { ButtonProps } from "common/UIKit/Button/Button";

interface Props {
  buttons: ButtonProps[];
  className?: string;
}

export const PatientStepsActions = ({ buttons, className }: Props) => (
  <div className={cn("patient-step__actions", className)}>
    {buttons.map((buttonProps, index) => {
      const { className, ...other } = buttonProps;
      return (
        <Button
          key={index}
          className={cn("patient-step__btn w-100", className)}
          {...other}
          size="lg"
        />
      );
    })}
  </div>
);
